module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-lo"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.item && _vm.item !== null) ? _c('span', {
    staticClass: "lo-modal-title"
  }, [_vm._v("SỬA TÊN KÊNH")]) : _c('span', {
    staticClass: "lo-modal-title"
  }, [_vm._v("THÊM KÊNH")]), _c('span', {
    staticClass: "lo-modal-btn-close material-icons",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("close")])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "reg-content"
  }, [_c('div', {
    staticClass: "form-group",
    class: [_vm.isSubmitFinish && (_vm.key_name.length === 0 || (_vm.key_name.length > 0 && _vm.key_exists)) ? 'error' : '']
  }, [(_vm.item && _vm.item !== null) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v("Tên kênh")]) : _c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nhập tên kênh")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.key_name),
      expression: "key_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "key_name",
      "placeholder": "Nhập tên kênh muốn thêm",
      "maxlength": "125"
    },
    domProps: {
      "value": (_vm.key_name)
    },
    on: {
      "keyup": _vm.onChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.key_name = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), (_vm.key_name.length === 0) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("Vui lòng nhập tên kênh")]) : _vm._e(), (_vm.isSubmitFinish && _vm.key_name.length > 0 && _vm.key_exists) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("Tên kênh đã tồn tại")]) : _vm._e()])])]), _c('div', {
    staticClass: "modal-footer lo-custom-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-12 text-center popup-button"
  }, [(_vm.item && _vm.item !== null) ? _c('button', {
    staticClass: "btn-active btn-popup",
    on: {
      "click": _vm.submitChannel
    }
  }, [_vm._v("Lưu thay đổi")]) : _c('button', {
    staticClass: "btn-active btn-popup",
    on: {
      "click": _vm.submitChannel
    }
  }, [_vm._v("Thêm mới")]), _c('button', {
    staticClass: "btn-popup",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("Huỷ yêu cầu")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24d9d642","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Channel/popup.vue
// module id = 1515
// module chunks = 0